import React, { Component } from 'react';
import ImgDI from '../Images/BlogDI.jpg';
import ImgDIH from '../Images/BlogDIH.jpg';


export class Blogs extends Component {
    render() {
        return (
            <div>
                <div>
                    <strong>
                        <center>
                            <h2>Artículos relacionados</h2>
                        </center>
                    </strong>
                </div>
                <div>
                    <center>
                        <div style={{ margin: "30px", width: "300px", display: "inline-block" }} >
                            <a href="/Blogs/discapacidad-cognitiva-aspectos-clave" style={{textDecorations:"none"}}>
                                <div>
                                    <img style={{ width: "300px" }} src={ImgDI} />
                                </div>
                                <div>
                                    <strong>
                                        <h3>
                                            Discapacidad intelectual: aspectos clave
                                        </h3>
                                    </strong>
                                </div>
                            </a>
                        </div>
                        <div style={{ margin: "30px", width: "300px", display: "inline-block" }} >
                            <a href="/Blogs/discapacidad-cognitiva-herramientas-diagnostico" style={{texDecorations:"none"}}>
                                <div>
                                    <img style={{ width: "300px" }} src={ImgDIH} />
                                </div>
                                <div>
                                    <strong>
                                        <h3>
                                            Herramientas de diagnóstico en discapacidad intelectual
                                        </h3>
                                    </strong>
                                </div>
                            </a>

                        </div>
                    </center>
                </div>
            </div>
        )
    }
}
export default Blogs;


// WEBPACK FOOTER //
// ./src/components/Blogs.js